// extracted by mini-css-extract-plugin
export var container = "_34-0";
export var error = "_34-9";
export var label = "_34-5";
export var light = "_34-6";
export var md = "_34-3";
export var sm = "_34-2";
export var thin = "_34-8";
export var thinBold = "_34-7";
export var vertical = "_34-4";
export var xs = "_34-1";